import { Capacitor } from '@capacitor/core';
import { Navigate } from 'react-router-dom';
import { ROLES } from '../consts/language';
import FoodTruckLayout from '../layout/FoodTruckLayout/FoodTruckLayout';
import MainLayout from '../layout/MainLayout/MainLayout';
import CategoriesManagement from '../pages/CategoriesManagement/CategoriesManagement';
import Dashboard from '../pages/Dashboard/Dashboard';
import { OrderType } from '../pages/Dashboard/order.types';
import FoodTruckGameSchedule from '../pages/GameSchedule/FoodTruckGameSchedule';
import GameSchedule from '../pages/GameSchedule/GameSchedule';
import MenuManagement from '../pages/MenuManagement/MenuManagement';
import OrderHistory from '../pages/OrderHistory/OrderHistory';
import PreOrderList from '../pages/OrderHistory/PreOrderList';
import OrderManagment from '../pages/OrderManagment/OrderManagment';
import PreorderRulesPage from '../pages/PreoderRules/PreorderRulesPage';
import PrinterSettings from '../pages/PrinterSettings/PrinterSettings';
import SettingsGuard from '../pages/Settings/SettingsGuard';
import UserMenu from '../pages/UserMenus/UserMenu';
import { MenuType } from '../pages/UserMenus/userMenu.types';

export const protectedRoutes = (userRole: string) => {
  const isNativeApp =
    typeof Capacitor !== 'undefined' &&
    (typeof (Capacitor as any).isNativePlatform === 'function'
      ? (Capacitor as any).isNativePlatform()
      : typeof (Capacitor as any).getPlatform === 'function'
        ? (Capacitor as any).getPlatform() !== 'web'
        : !!(typeof window !== 'undefined' && (window as any).Capacitor));

  if (userRole === ROLES.STAFF) {
    return [
      {
        path: '/',
        element: <Navigate to="/dashboard" />,
      },
      {
        path: '/',
        element: <MainLayout />,
        children: [
          { path: '/dashboard/*', element: <Dashboard /> },
          { path: '/order_management/*', element: <OrderManagment /> },
          { path: '/order_history/*', element: <OrderHistory /> },
          { path: '/menu_management/*', element: <MenuManagement /> },
          { path: '/pre_orders/*', element: <PreOrderList /> },
          { path: '/game_schedule/*', element: <FoodTruckGameSchedule /> },
          { path: '/settings/*', element: <SettingsGuard /> },
          ...(isNativeApp ? [{ path: '/settings_printer/*', element: <PrinterSettings /> }] : []),
          { path: '*', element: <Navigate to="dashboard" /> },
        ],
      },
    ];
  } else if (userRole === ROLES.SUPER_ADMIN) {
    return [
      {
        path: '/',
        element: <Navigate to="/categories_management" />,
      },
      {
        path: '/',
        element: <MainLayout />,
        children: [
          { path: '/order_history', element: <OrderHistory /> },
          { path: '/order_history/regular_orders', element: <OrderHistory orderType={OrderType.REGULAR_ORDERS} /> },
          { path: '/order_history/regular_pre_orders', element: <OrderHistory orderType={OrderType.REGULAR_PRE_ORDERS} /> },
          { path: '/order_history/special_orders', element: <OrderHistory orderType={OrderType.SPECIAL_ORDERS} /> },
          { path: '/order_history/special_pre_orders', element: <OrderHistory orderType={OrderType.SPECIAL_PRE_ORDERS} /> },
          // User Menus routes
          { path: '/user_menus/regular_orders', element: <UserMenu menuType={MenuType.REGULAR_ORDERS} /> },
          { path: '/user_menus/regular_pre_orders', element: <UserMenu menuType={MenuType.REGULAR_PRE_ORDERS} /> },
          { path: '/user_menus/special_orders', element: <UserMenu menuType={MenuType.SPECIAL_ORDERS} /> },
          { path: '/user_menus/special_pre_orders', element: <UserMenu menuType={MenuType.SPECIAL_PRE_ORDERS} /> },
          // Food Trucks routes
          {
            path: '/food_trucks/:restaurantId',
            element: <FoodTruckLayout />,
            children: [
              { path: '', element: <Navigate to="dashboard" /> },
              { path: 'dashboard', element: <Dashboard /> },
              { path: 'order_management', element: <OrderManagment /> },
              { path: 'order_history', element: <OrderHistory /> },
              { path: 'pre_orders', element: <PreOrderList /> },
              { path: 'menu_management', element: <MenuManagement /> },
              { path: 'game_schedule', element: <FoodTruckGameSchedule /> },
            ],
          },
          // Astrolab Store route
          {
            path: '/astrolab-store/:astrolabStoreId',
            element: <FoodTruckLayout />,
            children: [
              { path: '', element: <Navigate to="dashboard" /> },
              { path: 'dashboard', element: <Dashboard /> },
              { path: 'order_management', element: <OrderManagment /> },
              { path: 'order_history', element: <OrderHistory /> },
              { path: 'menu_management', element: <MenuManagement /> },
              { path: 'pre_orders', element: <PreOrderList /> },
              { path: 'game_schedule', element: <FoodTruckGameSchedule /> },
              ...(isNativeApp ? [{ path: 'settings_printer', element: <PrinterSettings /> }] : []),
            ],
          },
          // Game Schedule route
          { path: '/game_schedule', element: <GameSchedule /> },
          // Pre_Orders routes
          { path: '/pre_orders', element: <PreOrderList /> },
          { path: '/pre_orders/regular', element: <PreOrderList orderType={OrderType.REGULAR_PRE_ORDERS} /> },
          { path: '/pre_orders/special', element: <PreOrderList orderType={OrderType.SPECIAL_PRE_ORDERS} /> },
          // Pre Order Rules route
          { path: '/pre_order_rules', element: <PreorderRulesPage /> },
          // Seats Management route
          { path: '/seats_management', element: <OrderHistory /> },
          // Categories Management route
          { path: '/categories_management', element: <CategoriesManagement /> },
          // Order Management route
          { path: '/order_management', element: <OrderManagment /> },
          // settings_printer route
          ...(isNativeApp ? [{ path: '/settings_printer/*', element: <PrinterSettings /> }] : []),
          //
          { path: '*', element: <Navigate to="categories_management" /> },
        ],
      },
    ];
  } else {
    return [
      {
        path: '/',
        element: <Navigate to="/order_history" />,
      },
      {
        path: '/',
        element: <MainLayout />,
        children: [
          { path: '/order_history', element: <OrderHistory /> },
          { path: '/order_history/regular_orders', element: <OrderHistory orderType={OrderType.REGULAR_ORDERS} /> },
          { path: '/order_history/regular_pre_orders', element: <OrderHistory orderType={OrderType.REGULAR_PRE_ORDERS} /> },
          { path: '/order_history/special_orders', element: <OrderHistory orderType={OrderType.SPECIAL_ORDERS} /> },
          { path: '/order_history/special_pre_orders', element: <OrderHistory orderType={OrderType.SPECIAL_PRE_ORDERS} /> },
          { path: '*', element: <Navigate to="order_history" /> },
        ],
      },
    ];
  }
};
